import {useState,useEffect,useCallback} from 'react';

const UNIT_DATA={
    Length:{meter:1,km:0.001,mile:0.000621371,feet:3.28084},
    Weight:{gram:1,kg:0.001,pound:0.00220462,ounce:0.035274},
};
export const useConverter=()=>{
    const[rates,setRates]=useState({});
    const[loading,setLoading]=useState(true);
    useEffect(()=>{
        fetch('https://open.er-api.com/v6/latest/USD')
        .then(res=>res.json())
        .then(data=>{
            setRates(data.rates);
            setLoading(false);
        })
        .catch(err=>console.error("currenct fetch failed",err));
    }, []);
    const convert=useCallback((value,from,to,type)=>{
        const amount=parseFloat(value);
        if(isNaN(amount)) return "";
        if(type==="Currency"){
            if(!rates[from]||!rates[to]) return "";
            return ((amount/rates[from])*rates[to]).toFixed(2);
        }else{
            const baseValue=amount/UNIT_DATA[type][from];
            return (baseValue*UNIT_DATA[type][to]).toFixed(4);
        }
    }, [rates]);
    return {convert,rates, loading,units:UNIT_DATA };
}